@if (inputForm().errors) {
  <ul style="margin-left: 15px">
    @for (error of inputForm().errors | keyvalue; track error.key) {
      <li style="color: red">
        {{ getErrorMessage(error.key, error.value) }}
      </li>
    }
  </ul>
}
